export default "__VITE_ASSET__DXW19kHd__"